export default __webpack_public_path__ + "static/media/bg-05.edb7ad05.jpg";